<template>
  <v-layout class="user-signature"
    column
    wrap>
    <v-flex>
      <v-card
        class="elevation-1 paper">
        <div class="sign">
          <img class="image"
            v-if="!loading.show || loading.component !== 'UserSignature'"
            :src="user.signature.url"
            :alt="`Assinatura de ${user.name}`"
          >

          <v-progress-circular
            v-if="loading.show && loading.component === 'UserSignature'"
            class="image"
            style="min-height: 105px"
            indeterminate
            :width="2"
          />

          <v-divider class="baseline" />

          <strong class="name">
            {{user.name}}
          </strong>

          <small class="administrativeunit">
            {{user.administrative_unit.abbreviation || user.administrative_unit.name}}
          </small>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'SignatureUser',
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
};
</script>

<style scoped lang="scss">
.user-signature {
  .assigned {
    min-width: 100%;
  }

  .paper {
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .sign {
    & {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }

  .image {
    margin: 0 2rem;
    max-width: 140px;
  }

  .baseline {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/signature/UserSignature.vue